<div class="multi-panel">
    <mat-card>
        <mat-card-header>
          <mat-card-title><a [routerLink]="link">{{ header }}</a></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-content select="[multi-panel-body]"></ng-content>
        </mat-card-content>
        <mat-card-actions>
            <ng-content select="[multi-panel-actions]"></ng-content>
        </mat-card-actions>
    </mat-card>    
</div>

<style lang="scss">
.multi-panel .mat-card {
    padding: 0;
}

.multi-panel .mat-card-actions, .mat-card-content, .mat-card-subtitle, .mat-card-title {
    margin-bottom: 0;
}

.multi-panel .mat-card-header {
    background: #696969;
}

.multi-panel .mat-card-title {
    padding: 10px;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.multi-panel .mat-card-title a {
    text-transform: uppercase;
}

.multi-panel .mat-card-content {
    /* padding: .6em 1em;
    margin: 10px 0; */
    /* max-height: 100px; */
    overflow-y: scroll;
}

.multi-panel .mat-card-actions {
    margin: 0;
    padding: 0;
    background: gainsboro;
}

</style>
